// @flow

import _ from 'lodash';

class SessionUtils {

  static saveObjectToSession(key, object) {
    const json = JSON.stringify(object);
    localStorage.setItem(key, json);
  }

  /**
   * @param key see Constant.Session
   * @param value the value to save on the session
   */
  static saveItemToSession(key: string, value: Object) {
//    console.log('[SESSION] SAVE ', key, ' : ', value);
    SessionUtils.saveObjectToSession(key, value);
  }

  /**
   * @param key see Constant.Session
   * @param defaultValue
   */
  static getItemFromSession(key: string, defaultValue: ?any = null): ?any {
    const value = SessionUtils.getObjectFromSession(key, defaultValue);
//    console.log('[SESSION] GET ', key, ' : ', value);
    return value;
  }

  static getObjectFromSession(key: string, defaultValue: ?Object = null): ?any {
    const obj: ?string = localStorage.getItem(key);

    let value: ?any = null;

    // default value
    if (_.isUndefined(obj) || _.isNull(obj)) {
      if (!_.isUndefined(defaultValue) && !_.isNull(defaultValue)) {
        value = defaultValue;
      }
    } else {
      try {
        value = JSON.parse(obj);
      } catch (e) {
        value = obj;
      }
    }

    return value;
  }

  static getFloatItemFromSession(key: string, defaultReturn: number = 0): number {
    let value = this.getObjectFromSession(key);

    // default value
    if (_.isNil(value) || _.isNaN(value)) {
      if (!_.isUndefined(defaultReturn) && !_.isNull(defaultReturn)) {
        value = defaultReturn;
      } else {
        value = 0;
      }
    }
//    console.log('[SESSION] GET ', key, ' : ', value);
    const intValue = parseFloat(value);
    if (_.isNaN(intValue)) {
      return defaultReturn;
    }
    return intValue;
  }

  static getIntItemFromSession(key: string, defaultReturn: number = 0): number {
    let value = localStorage.getItem(key);

    // default value
    if (_.isUndefined(value) || _.isNull(value) || _.isNaN(value)) {
      if (!_.isUndefined(defaultReturn) && !_.isNull(defaultReturn)) {
        value = defaultReturn;
      } else {
        value = 0;
      }
    }

    const intValue = parseInt(value, 10);
    if (_.isNaN(intValue)) {
      return defaultReturn;
    }
    return intValue;
  }

}

export default SessionUtils;
